import { useState } from 'react';
import { useUser } from '../../contexts/user';
import { Input, InputPicker, Button } from 'rsuite';
import { updateProfile } from '../../core';
import { useNavigate } from 'react-router-dom';
import saveIcon from '../../assets/icons/save.svg';
// import calendarIcon from '../../assets/icons/calendar.svg';
import cancelIcon from '../../assets/icons/cancel.svg';
import { Datepicker } from '@ijavad805/react-datepicker';
import { convertJalaliTo, convertToJalali } from '../../utils/helpers';
import { showToast } from '../../utils/toast';
// import moment from 'moment';
export const Profile = () => {
  const { user, setUserTrigger, userTrigger } = useUser();
  const navigate = useNavigate();
  const [father, setFather] = useState<string | null>(user.father_name);
  const [gender, seGender] = useState<number | null>(user.gender);
  const [married, setMarried] = useState<number | null>(user.married);
  const [defaultdate] = useState(user.date_of_birth);
  const [selectedDate, setSelectedDate] = useState(new Date(convertJalaliTo(defaultdate)));

  const handleUpdateProfile = async () => {
    console.log('father', father);
    console.log('gender', gender);
    console.log('married', married);
    try {
      const res = await updateProfile({
        date_of_birth: convertToJalali(new Date(selectedDate)),
        father_name: father,
        gender,
        married
      });
      console.log(res);
      setUserTrigger(!userTrigger);
      showToast('اطلاعات با موفقیت بروزرسانی شد.', 'success');
      // navigate('/');
    } catch (e) {
      showToast('مشکلی پیش آمده!', 'error');
      console.log(e);
    }
  };
  return (
    <div className="flex flex-col">
      <span className="text-lg text-center mt-5">
        {user.name} {user.family}
      </span>
      <div className="w-[90%] mx-auto">
        <div className="mb-1 mt-5">نام پدر</div>
        <Input
          type="text"
          value={father ?? ''}
          name="father_name"
          placeholder=""
          onChange={setFather}
          dir="rtl"
        />
        <div className="mb-1 mt-5">تاریخ تولد</div>
        <Datepicker
          lang={'fa'}
          theme={'green'}
          value={selectedDate.toISOString()}
          input={
            <Input
              className="w-full"
              placeholder="تاریخ را انتخاب کنید"
              value={new Intl.DateTimeFormat('fa-IR', {
                weekday: 'long',
                year: 'numeric',
                month: 'numeric',
                day: 'numeric'
              }).format(selectedDate)}
            />
          }
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          onChange={(val: any) => {
            setSelectedDate(val);
          }}
        />
        {/* {new Intl.DateTimeFormat('fa-IR', {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric'
        }).format(selectedDate)} */}

        <div className="mb-1 mt-5">جنسیت</div>
        <InputPicker
          value={gender ?? 1}
          onChange={seGender}
          dir="rtl"
          className="w-[100%]"
          data={[
            { label: 'مرد', value: 1 },
            { label: 'زن', value: 2 }
          ]}
        />
        <div className="mb-1 mt-5">وضیعت تاهل</div>
        <InputPicker
          value={married ?? 1}
          onChange={setMarried}
          dir="rtl"
          className="w-[100%]"
          data={[
            { label: 'مجرد', value: 1 },
            { label: 'متاهل', value: 2 },
            { label: 'جدا شده', value: 3 }
          ]}
        />

        <div className="flex justify-between">
          <Button
            appearance="primary"
            className="btn-outline mt-5"
            type="button"
            onClick={handleUpdateProfile}>
            <img className="ml-1" src={saveIcon} alt="" />
            ذخیره
          </Button>
          <Button
            appearance="default"
            className="btn-outline mt-5"
            type="button"
            onClick={() => navigate('/')}>
            <img className="ml-1" src={cancelIcon} alt="" />
            انصراف
          </Button>
        </div>
      </div>
    </div>
  );
};
